/**
 * @generated SignedSource<<518e5d26d0c62861627695d7f7cabcb2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type initSierraChat_user$data = {
  readonly emailToken: string | null;
  readonly serviceId: string | null;
  readonly sfChatToken: string | null;
  readonly token: string | null;
  readonly " $fragmentType": "initSierraChat_user";
};
export type initSierraChat_user$key = {
  readonly " $data"?: initSierraChat_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"initSierraChat_user">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "initSierraChat_user"
};

(node as any).hash = "e255a5b21037a0a02625d4d1390c768d";

export default node;
